import { getFontSize } from "../../themes";
import { EFontSizes, EFontWeights } from "../../themes/types";
export var HeadingStyles = function () {
    return {
        wrapper: {
            fontSize: getFontSize(EFontSizes.Medium),
            fontWeight: EFontWeights.Medium,
        },
    };
};
